import ApiClient from "../helpers/ApiClient";

const baseCobrancaEndpoint = (cnpj) => `/empresa/${cnpj}/cobrancas`;
const configCobrancaEndpoint = (cnpj) => `/gestao/empresa/${cnpj}/config`;

const listCobrancas = (cnpj, params) =>
  ApiClient.apiClientDev.get(baseCobrancaEndpoint(cnpj), { params });

const getCobranca = (cnpj, uid) =>
  ApiClient.apiClientDev.get(`${baseCobrancaEndpoint(cnpj)}/${uid}`);

const getConfig = (cnpj) =>
  ApiClient.apiClientDev.get(configCobrancaEndpoint(cnpj));

const postConfig = (cnpj, data) =>
  ApiClient.apiClientDev.post(configCobrancaEndpoint(cnpj), data);

const postCobranca = (cnpj, data) =>
  ApiClient.apiClientDev.post(baseCobrancaEndpoint(cnpj), data, {
    headers: { "Content-Type": "application/json" },
  });

const reabrirEdicao = (cnpj, uid) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/reabrir_edicao/${uid}`,
    null,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

const autorizarGeracao = (cnpj, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/autorizar_geracao/`,
    data
  );

const putCobranca = (cnpj, uid, data) =>
  ApiClient.apiClientDev.put(`${baseCobrancaEndpoint(cnpj)}/${uid}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const deleteCobranca = (cnpj, uid) =>
  ApiClient.apiClientDev.delete(`${baseCobrancaEndpoint(cnpj)}/${uid}`);

const emitirCobranca = (cnpj, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/emitir_boletos/`,
    data
  );

const copiarMesAnterior = (cnpj, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/copiar_mes_anterior/`,
    data
  );

const solicitarCancelamento = (cnpj, uid, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/solicitar_cancelamento/${uid}`,
    data
  );

const cancelarCobranca = (cnpj, uid) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/cancelar/${uid}`,
    null
  );

const informarPagamento = (cnpj, uid, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/informar_pagamento/${uid}`,
    data
  );

const cancelarPagamento = (cnpj, uid) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/cancelar_pagamento/${uid}`,
    null
  );

const downloadMassa = (cnpj, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/download_massa/`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "arraybuffer",
    }
  );

const enviarEmail = (cnpj, uid, data) =>
  ApiClient.apiClientDev.post(
    `${baseCobrancaEndpoint(cnpj)}/enviar_email/${uid}`,
    data
  );

const visualizarCobranca = (cnpj, params) =>
  ApiClient.apiClientDev.get(`${baseCobrancaEndpoint(cnpj)}/visualizar/`, {
    params,
    responseType: "arraybuffer",
  });

const postLogo = (cnpj, data) =>
  ApiClient.apiClientDev.post(`${configCobrancaEndpoint(cnpj)}/logo`, data);

const CobrancaApiClient = {
  listCobrancas,
  getCobranca,
  getConfig,
  postConfig,
  postCobranca,
  reabrirEdicao,
  autorizarGeracao,
  putCobranca,
  deleteCobranca,
  emitirCobranca,
  copiarMesAnterior,
  solicitarCancelamento,
  informarPagamento,
  cancelarPagamento,
  cancelarCobranca,
  downloadMassa,
  enviarEmail,
  visualizarCobranca,
  postLogo,
};
export default CobrancaApiClient;
